/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LootshopTransactionHistoryResponsePagination
 */
export interface LootshopTransactionHistoryResponsePagination {
    /**
     * Total number of LootShop orders
     * @type {number}
     * @memberof LootshopTransactionHistoryResponsePagination
     */
    total?: number;
    /**
     * Number of transactions per page
     * @type {number}
     * @memberof LootshopTransactionHistoryResponsePagination
     */
    limit?: number;
    /**
     * Starting offset
     * @type {number}
     * @memberof LootshopTransactionHistoryResponsePagination
     */
    offset?: number;
    /**
     * Whether more transactions exist
     * @type {boolean}
     * @memberof LootshopTransactionHistoryResponsePagination
     */
    hasMore?: boolean;
}

/**
 * Check if a given object implements the LootshopTransactionHistoryResponsePagination interface.
 */
export function instanceOfLootshopTransactionHistoryResponsePagination(value: object): value is LootshopTransactionHistoryResponsePagination {
    return true;
}

export function LootshopTransactionHistoryResponsePaginationFromJSON(json: any): LootshopTransactionHistoryResponsePagination {
    return LootshopTransactionHistoryResponsePaginationFromJSONTyped(json, false);
}

export function LootshopTransactionHistoryResponsePaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): LootshopTransactionHistoryResponsePagination {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'] == null ? undefined : json['total'],
        'limit': json['limit'] == null ? undefined : json['limit'],
        'offset': json['offset'] == null ? undefined : json['offset'],
        'hasMore': json['hasMore'] == null ? undefined : json['hasMore'],
    };
}

export function LootshopTransactionHistoryResponsePaginationToJSON(json: any): LootshopTransactionHistoryResponsePagination {
    return LootshopTransactionHistoryResponsePaginationToJSONTyped(json, false);
}

export function LootshopTransactionHistoryResponsePaginationToJSONTyped(value?: LootshopTransactionHistoryResponsePagination | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': value['total'],
        'limit': value['limit'],
        'offset': value['offset'],
        'hasMore': value['hasMore'],
    };
}

